/* eslint-disable no-restricted-imports */
import type { Logger } from '@feature-hub/logger';
import type { VueFormatterFeatureServiceInterfaceV1 } from '@oneaudi/vue-formatter-service/lib/cjs/v1/vue-formatter-feature-service';
import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import normalizeContent from './contexts/ContentMapping';
import type { FaceEditorContent, FalconContent } from './contexts/ContentInterfaces';
import { getPerSlideWltpCompliance } from './wltpCompliance';

export interface SsrWltpPrecheckArgs {
  isMarketComplianceEnabled: boolean;
  content: unknown;
  vueFormatterService?: VueFormatterFeatureServiceInterfaceV1;
  serviceLocale?: LocaleServiceV1;
  logger?: Pick<Logger, 'warn' | 'error'>;
  onCaeMissingLog?: (message: string) => void;
}

export const runSsrWltpPrecheck = async ({
  isMarketComplianceEnabled,
  content,
  vueFormatterService,
  serviceLocale,
  logger,
  onCaeMissingLog,
}: SsrWltpPrecheckArgs): Promise<boolean[] | undefined> => {
  if (!isMarketComplianceEnabled) return undefined;
  if (!vueFormatterService || !serviceLocale) return undefined;

  try {
    const mapped = normalizeContent(content as FalconContent | FaceEditorContent);
    return await getPerSlideWltpCompliance(
      mapped.gallery,
      vueFormatterService,
      serviceLocale,
      logger,
      onCaeMissingLog,
    );
  } catch (err) {
    logger?.warn('WLTP SSR compliance pre-check failed', err);
    return undefined;
  }
};
